import { WorkflowModuleSurfaceRegistry } from './workflow-module-surface.registry';

export function registerGrowthWorkflowSurfaces(registry: WorkflowModuleSurfaceRegistry): void {
  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.content.review',
    titleKey: 'growth.workflow.surfaces.contentReview.title',
    descriptionKey: 'growth.workflow.surfaces.contentReview.description',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-content-review-task-surface.component').then(
        module => module.GrowthContentReviewTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.agent.recommendationApproval',
    titleKey: 'growth.workflow.surfaces.agentRecommendation.title',
    descriptionKey: 'growth.workflow.surfaces.agentRecommendation.description',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-agent-recommendation-task-surface.component').then(
        module => module.GrowthAgentRecommendationTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.strategy.activationApproval',
    titleKey: 'growth.workflow.surfaces.activationPlan.title',
    descriptionKey: 'growth.workflow.surfaces.activationPlan.description',
    fullPageRouteTemplate: '/growth/strategy/activation-plans/:activationPlanId',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-activation-plan-task-surface.component').then(
        module => module.GrowthActivationPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.strategy.artifactApproval',
    titleKey: 'growth.workflow.surfaces.strategyArtifact.title',
    descriptionKey: 'growth.workflow.surfaces.strategyArtifact.description',
    fullPageRouteTemplate: '/growth/agents/strategy-artifacts/:id',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-strategy-artifact-approval-task-surface.component').then(
        module => module.GrowthStrategyArtifactApprovalTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.publish.planApproval',
    titleKey: 'growth.workflow.surfaces.publishPlan.title',
    descriptionKey: 'growth.workflow.surfaces.publishPlan.description',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-publish-plan-task-surface.component').then(
        module => module.GrowthPublishPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.campaign.approval',
    titleKey: 'growth.workflow.surfaces.campaignApproval.title',
    descriptionKey: 'growth.workflow.surfaces.campaignApproval.description',
    fullPageRouteTemplate: '/growth/marketing/campaigns/:campaignId',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-campaign-approval-task-surface.component').then(
        module => module.GrowthCampaignApprovalTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.crm.leadHandoffReview',
    titleKey: 'growth.workflow.surfaces.leadHandoff.title',
    descriptionKey: 'growth.workflow.surfaces.leadHandoff.description',
    fullPageRouteTemplate: '/growth/crm/leads/:leadId',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-lead-handoff-review-task-surface.component').then(
        module => module.GrowthLeadHandoffReviewTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.storefront.applyApproval',
    titleKey: 'growth.workflow.surfaces.storefrontApply.title',
    descriptionKey: 'growth.workflow.surfaces.storefrontApply.description',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-storefront-apply-task-surface.component').then(
        module => module.GrowthStorefrontApplyTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.discoveryCreate',
    titleKey: 'growth.workflow.surfaces.journey.discoveryCreate.title',
    descriptionKey: 'growth.workflow.surfaces.journey.discoveryCreate.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/new',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-discovery-task-surface.component').then(
        module => module.GrowthJourneyDiscoveryTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.discoveryView',
    titleKey: 'growth.workflow.surfaces.journey.discoveryView.title',
    descriptionKey: 'growth.workflow.surfaces.journey.discoveryView.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-discovery-task-surface.component').then(
        module => module.GrowthJourneyDiscoveryTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.discoveryEdit',
    titleKey: 'growth.workflow.surfaces.journey.discoveryEdit.title',
    descriptionKey: 'growth.workflow.surfaces.journey.discoveryEdit.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-discovery-task-surface.component').then(
        module => module.GrowthJourneyDiscoveryTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.discoverySelect',
    titleKey: 'growth.workflow.surfaces.journey.discoverySelect.title',
    descriptionKey: 'growth.workflow.surfaces.journey.discoverySelect.description',
    fullPageRouteTemplate: '/growth/journey/discoveries',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-discovery-task-surface.component').then(
        module => module.GrowthJourneyDiscoveryTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.discoveryApprove',
    titleKey: 'growth.workflow.surfaces.journey.discoveryApprove.title',
    descriptionKey: 'growth.workflow.surfaces.journey.discoveryApprove.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-discovery-task-surface.component').then(
        module => module.GrowthJourneyDiscoveryTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketCompetitor',
    titleKey: 'growth.workflow.surfaces.journey.marketCompetitor.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketCompetitor.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#market-competitors',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-market-competitor-task-surface.component').then(
        module => module.GrowthJourneyMarketCompetitorTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketCompetitorCreate',
    titleKey: 'growth.workflow.surfaces.journey.marketCompetitor.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketCompetitor.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#market-competitors',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-market-competitor-task-surface.component').then(
        module => module.GrowthJourneyMarketCompetitorTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketCompetitorView',
    titleKey: 'growth.workflow.surfaces.journey.marketCompetitor.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketCompetitor.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#market-competitors',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-market-competitor-task-surface.component').then(
        module => module.GrowthJourneyMarketCompetitorTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketCompetitorEdit',
    titleKey: 'growth.workflow.surfaces.journey.marketCompetitor.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketCompetitor.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#market-competitors',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-market-competitor-task-surface.component').then(
        module => module.GrowthJourneyMarketCompetitorTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketCompetitorSelect',
    titleKey: 'growth.workflow.surfaces.journey.marketCompetitor.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketCompetitor.description',
    fullPageRouteTemplate: '/growth/journey/discoveries',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-market-competitor-task-surface.component').then(
        module => module.GrowthJourneyMarketCompetitorTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketCompetitorApprove',
    titleKey: 'growth.workflow.surfaces.journey.marketCompetitor.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketCompetitor.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#market-competitors',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-market-competitor-task-surface.component').then(
        module => module.GrowthJourneyMarketCompetitorTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.swot',
    titleKey: 'growth.workflow.surfaces.journey.swot.title',
    descriptionKey: 'growth.workflow.surfaces.journey.swot.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#swot',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-swot-task-surface.component').then(
        module => module.GrowthJourneySwotTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.swotCreate',
    titleKey: 'growth.workflow.surfaces.journey.swot.title',
    descriptionKey: 'growth.workflow.surfaces.journey.swot.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#swot',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-swot-task-surface.component').then(
        module => module.GrowthJourneySwotTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.swotView',
    titleKey: 'growth.workflow.surfaces.journey.swot.title',
    descriptionKey: 'growth.workflow.surfaces.journey.swot.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#swot',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-swot-task-surface.component').then(
        module => module.GrowthJourneySwotTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.swotEdit',
    titleKey: 'growth.workflow.surfaces.journey.swot.title',
    descriptionKey: 'growth.workflow.surfaces.journey.swot.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#swot',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-swot-task-surface.component').then(
        module => module.GrowthJourneySwotTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.swotSelect',
    titleKey: 'growth.workflow.surfaces.journey.swot.title',
    descriptionKey: 'growth.workflow.surfaces.journey.swot.description',
    fullPageRouteTemplate: '/growth/journey/discoveries',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-swot-task-surface.component').then(
        module => module.GrowthJourneySwotTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.swotApprove',
    titleKey: 'growth.workflow.surfaces.journey.swot.title',
    descriptionKey: 'growth.workflow.surfaces.journey.swot.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#swot',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-swot-task-surface.component').then(
        module => module.GrowthJourneySwotTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.situationAssessment',
    titleKey: 'growth.workflow.surfaces.journey.situationAssessment.title',
    descriptionKey: 'growth.workflow.surfaces.journey.situationAssessment.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#situation-assessment',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-situation-assessment-task-surface.component').then(
        module => module.GrowthJourneySituationAssessmentTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.situationAssessmentCreate',
    titleKey: 'growth.workflow.surfaces.journey.situationAssessment.title',
    descriptionKey: 'growth.workflow.surfaces.journey.situationAssessment.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#situation-assessment',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-situation-assessment-task-surface.component').then(
        module => module.GrowthJourneySituationAssessmentTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.situationAssessmentView',
    titleKey: 'growth.workflow.surfaces.journey.situationAssessment.title',
    descriptionKey: 'growth.workflow.surfaces.journey.situationAssessment.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#situation-assessment',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-situation-assessment-task-surface.component').then(
        module => module.GrowthJourneySituationAssessmentTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.situationAssessmentEdit',
    titleKey: 'growth.workflow.surfaces.journey.situationAssessment.title',
    descriptionKey: 'growth.workflow.surfaces.journey.situationAssessment.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#situation-assessment',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-situation-assessment-task-surface.component').then(
        module => module.GrowthJourneySituationAssessmentTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.situationAssessmentSelect',
    titleKey: 'growth.workflow.surfaces.journey.situationAssessment.title',
    descriptionKey: 'growth.workflow.surfaces.journey.situationAssessment.description',
    fullPageRouteTemplate: '/growth/journey/discoveries',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-situation-assessment-task-surface.component').then(
        module => module.GrowthJourneySituationAssessmentTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.situationAssessmentApprove',
    titleKey: 'growth.workflow.surfaces.journey.situationAssessment.title',
    descriptionKey: 'growth.workflow.surfaces.journey.situationAssessment.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#situation-assessment',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-situation-assessment-task-surface.component').then(
        module => module.GrowthJourneySituationAssessmentTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.positioning',
    titleKey: 'growth.workflow.surfaces.journey.positioning.title',
    descriptionKey: 'growth.workflow.surfaces.journey.positioning.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#positioning',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-positioning-task-surface.component').then(
        module => module.GrowthJourneyPositioningTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.positioningCreate',
    titleKey: 'growth.workflow.surfaces.journey.positioning.title',
    descriptionKey: 'growth.workflow.surfaces.journey.positioning.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#positioning',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-positioning-task-surface.component').then(
        module => module.GrowthJourneyPositioningTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.positioningView',
    titleKey: 'growth.workflow.surfaces.journey.positioning.title',
    descriptionKey: 'growth.workflow.surfaces.journey.positioning.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#positioning',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-positioning-task-surface.component').then(
        module => module.GrowthJourneyPositioningTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.positioningEdit',
    titleKey: 'growth.workflow.surfaces.journey.positioning.title',
    descriptionKey: 'growth.workflow.surfaces.journey.positioning.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#positioning',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-positioning-task-surface.component').then(
        module => module.GrowthJourneyPositioningTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.positioningSelect',
    titleKey: 'growth.workflow.surfaces.journey.positioning.title',
    descriptionKey: 'growth.workflow.surfaces.journey.positioning.description',
    fullPageRouteTemplate: '/growth/journey/discoveries',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-positioning-task-surface.component').then(
        module => module.GrowthJourneyPositioningTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.positioningApprove',
    titleKey: 'growth.workflow.surfaces.journey.positioning.title',
    descriptionKey: 'growth.workflow.surfaces.journey.positioning.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#positioning',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-positioning-task-surface.component').then(
        module => module.GrowthJourneyPositioningTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketingPlan',
    titleKey: 'growth.workflow.surfaces.journey.marketingPlan.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketingPlan.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#marketing-plan',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-marketing-plan-task-surface.component').then(
        module => module.GrowthJourneyMarketingPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketingPlanCreate',
    titleKey: 'growth.workflow.surfaces.journey.marketingPlan.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketingPlan.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#marketing-plan',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-marketing-plan-task-surface.component').then(
        module => module.GrowthJourneyMarketingPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketingPlanView',
    titleKey: 'growth.workflow.surfaces.journey.marketingPlan.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketingPlan.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#marketing-plan',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-marketing-plan-task-surface.component').then(
        module => module.GrowthJourneyMarketingPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketingPlanEdit',
    titleKey: 'growth.workflow.surfaces.journey.marketingPlan.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketingPlan.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#marketing-plan',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-marketing-plan-task-surface.component').then(
        module => module.GrowthJourneyMarketingPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketingPlanSelect',
    titleKey: 'growth.workflow.surfaces.journey.marketingPlan.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketingPlan.description',
    fullPageRouteTemplate: '/growth/journey/discoveries',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-marketing-plan-task-surface.component').then(
        module => module.GrowthJourneyMarketingPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.marketingPlanApprove',
    titleKey: 'growth.workflow.surfaces.journey.marketingPlan.title',
    descriptionKey: 'growth.workflow.surfaces.journey.marketingPlan.description',
    fullPageRouteTemplate: '/growth/journey/discoveries/:discoveryId#marketing-plan',
    requiredContextKeys: ['discoveryId'],
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-marketing-plan-task-surface.component').then(
        module => module.GrowthJourneyMarketingPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.activationPlan',
    titleKey: 'growth.workflow.surfaces.journey.activationPlan.title',
    descriptionKey: 'growth.workflow.surfaces.journey.activationPlan.description',
    fullPageRouteTemplate: '/growth/strategy/activation-plans/:activationPlanId',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-activation-plan-task-surface.component').then(
        module => module.GrowthJourneyActivationPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.activationPlanView',
    titleKey: 'growth.workflow.surfaces.journey.activationPlan.title',
    descriptionKey: 'growth.workflow.surfaces.journey.activationPlan.description',
    fullPageRouteTemplate: '/growth/strategy/activation-plans/:activationPlanId',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-activation-plan-task-surface.component').then(
        module => module.GrowthJourneyActivationPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.activationPlanEdit',
    titleKey: 'growth.workflow.surfaces.journey.activationPlan.title',
    descriptionKey: 'growth.workflow.surfaces.journey.activationPlan.description',
    fullPageRouteTemplate: '/growth/strategy/activation-plans/:activationPlanId',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-activation-plan-task-surface.component').then(
        module => module.GrowthJourneyActivationPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.activationPlanApprove',
    titleKey: 'growth.workflow.surfaces.journey.activationPlan.title',
    descriptionKey: 'growth.workflow.surfaces.journey.activationPlan.description',
    fullPageRouteTemplate: '/growth/strategy/activation-plans/:activationPlanId',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-activation-plan-task-surface.component').then(
        module => module.GrowthJourneyActivationPlanTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.calendar',
    titleKey: 'growth.workflow.surfaces.journey.calendar.title',
    descriptionKey: 'growth.workflow.surfaces.journey.calendar.description',
    fullPageRouteTemplate: '/growth/marketing/content-calendar',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-calendar-task-surface.component').then(
        module => module.GrowthJourneyCalendarTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.calendarView',
    titleKey: 'growth.workflow.surfaces.journey.calendar.title',
    descriptionKey: 'growth.workflow.surfaces.journey.calendar.description',
    fullPageRouteTemplate: '/growth/marketing/content-calendar',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-calendar-task-surface.component').then(
        module => module.GrowthJourneyCalendarTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.calendarEdit',
    titleKey: 'growth.workflow.surfaces.journey.calendar.title',
    descriptionKey: 'growth.workflow.surfaces.journey.calendar.description',
    fullPageRouteTemplate: '/growth/marketing/content-calendar',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-calendar-task-surface.component').then(
        module => module.GrowthJourneyCalendarTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.calendarApprove',
    titleKey: 'growth.workflow.surfaces.journey.calendar.title',
    descriptionKey: 'growth.workflow.surfaces.journey.calendar.description',
    fullPageRouteTemplate: '/growth/marketing/content-calendar',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-calendar-task-surface.component').then(
        module => module.GrowthJourneyCalendarTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.brief',
    titleKey: 'growth.workflow.surfaces.journey.brief.title',
    descriptionKey: 'growth.workflow.surfaces.journey.brief.description',
    fullPageRouteTemplate: '/growth/marketing/content-calendar',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-brief-task-surface.component').then(
        module => module.GrowthJourneyBriefTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.briefView',
    titleKey: 'growth.workflow.surfaces.journey.brief.title',
    descriptionKey: 'growth.workflow.surfaces.journey.brief.description',
    fullPageRouteTemplate: '/growth/marketing/content-calendar',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-brief-task-surface.component').then(
        module => module.GrowthJourneyBriefTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.briefEdit',
    titleKey: 'growth.workflow.surfaces.journey.brief.title',
    descriptionKey: 'growth.workflow.surfaces.journey.brief.description',
    fullPageRouteTemplate: '/growth/marketing/content-calendar',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-brief-task-surface.component').then(
        module => module.GrowthJourneyBriefTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.briefApprove',
    titleKey: 'growth.workflow.surfaces.journey.brief.title',
    descriptionKey: 'growth.workflow.surfaces.journey.brief.description',
    fullPageRouteTemplate: '/growth/marketing/content-calendar',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-brief-task-surface.component').then(
        module => module.GrowthJourneyBriefTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.contentProduction',
    titleKey: 'growth.workflow.surfaces.journey.contentProduction.title',
    descriptionKey: 'growth.workflow.surfaces.journey.contentProduction.description',
    fullPageRouteTemplate: '/growth/marketing/ace-studio',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-content-production-task-surface.component').then(
        module => module.GrowthJourneyContentProductionTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.contentProductionView',
    titleKey: 'growth.workflow.surfaces.journey.contentProduction.title',
    descriptionKey: 'growth.workflow.surfaces.journey.contentProduction.description',
    fullPageRouteTemplate: '/growth/marketing/ace-studio',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-content-production-task-surface.component').then(
        module => module.GrowthJourneyContentProductionTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.contentProductionEdit',
    titleKey: 'growth.workflow.surfaces.journey.contentProduction.title',
    descriptionKey: 'growth.workflow.surfaces.journey.contentProduction.description',
    fullPageRouteTemplate: '/growth/marketing/ace-studio',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-content-production-task-surface.component').then(
        module => module.GrowthJourneyContentProductionTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.contentProductionApprove',
    titleKey: 'growth.workflow.surfaces.journey.contentProduction.title',
    descriptionKey: 'growth.workflow.surfaces.journey.contentProduction.description',
    fullPageRouteTemplate: '/growth/marketing/ace-studio',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-content-production-task-surface.component').then(
        module => module.GrowthJourneyContentProductionTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.publish',
    titleKey: 'growth.workflow.surfaces.journey.publish.title',
    descriptionKey: 'growth.workflow.surfaces.journey.publish.description',
    fullPageRouteTemplate: '/growth/marketing/publish-operations',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-publish-task-surface.component').then(
        module => module.GrowthJourneyPublishTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.publishView',
    titleKey: 'growth.workflow.surfaces.journey.publish.title',
    descriptionKey: 'growth.workflow.surfaces.journey.publish.description',
    fullPageRouteTemplate: '/growth/marketing/publish-operations',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-publish-task-surface.component').then(
        module => module.GrowthJourneyPublishTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.publishEdit',
    titleKey: 'growth.workflow.surfaces.journey.publish.title',
    descriptionKey: 'growth.workflow.surfaces.journey.publish.description',
    fullPageRouteTemplate: '/growth/marketing/publish-operations',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-publish-task-surface.component').then(
        module => module.GrowthJourneyPublishTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.publishApprove',
    titleKey: 'growth.workflow.surfaces.journey.publish.title',
    descriptionKey: 'growth.workflow.surfaces.journey.publish.description',
    fullPageRouteTemplate: '/growth/marketing/publish-operations',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-publish-task-surface.component').then(
        module => module.GrowthJourneyPublishTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.monitoring',
    titleKey: 'growth.workflow.surfaces.journey.monitoring.title',
    descriptionKey: 'growth.workflow.surfaces.journey.monitoring.description',
    fullPageRouteTemplate: '/growth/journey/journeys/:journeyId',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-monitoring-task-surface.component').then(
        module => module.GrowthJourneyMonitoringTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.monitoringView',
    titleKey: 'growth.workflow.surfaces.journey.monitoring.title',
    descriptionKey: 'growth.workflow.surfaces.journey.monitoring.description',
    fullPageRouteTemplate: '/growth/journey/journeys/:journeyId',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-monitoring-task-surface.component').then(
        module => module.GrowthJourneyMonitoringTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.monitoringEdit',
    titleKey: 'growth.workflow.surfaces.journey.monitoring.title',
    descriptionKey: 'growth.workflow.surfaces.journey.monitoring.description',
    fullPageRouteTemplate: '/growth/journey/journeys/:journeyId',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-monitoring-task-surface.component').then(
        module => module.GrowthJourneyMonitoringTaskSurfaceComponent
      )
  });

  registry.register({
    moduleKey: 'growth-platform',
    surfaceKey: 'growth.journey.monitoringApprove',
    titleKey: 'growth.workflow.surfaces.journey.monitoring.title',
    descriptionKey: 'growth.workflow.surfaces.journey.monitoring.description',
    fullPageRouteTemplate: '/growth/journey/journeys/:journeyId',
    loadComponent: () =>
      import('../../features/growth/workflow-surfaces/growth-journey-monitoring-task-surface.component').then(
        module => module.GrowthJourneyMonitoringTaskSurfaceComponent
      )
  });
}
